export default __webpack_public_path__ + "static/media/Helvetica-Bold.e47e2f6d.ttf";